import { render, staticRenderFns } from "./CardImage.vue?vue&type=template&id=288251be&scoped=true"
import script from "./CardImage.vue?vue&type=script&lang=js"
export * from "./CardImage.vue?vue&type=script&lang=js"
import style0 from "./CardImage.vue?vue&type=style&index=0&id=288251be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288251be",
  null
  
)

export default component.exports